import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from '../../assets/svgs';
import styles from './style.module.css';
import Typography from '../../components/Typography/Typography';
import AnimatedCard from '../../components/AnimatedCard';

interface CarouselItem {
  id: number;
  image: string;
  galleryName: string;
  artist: string;
  artWork: string;
}

export const FeaturedStoreSection: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const carouselItems: CarouselItem[] = [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop',
      galleryName: 'Ancient Artifacts Gallery',
      artist: 'Various Artists',
      artWork: 'Classical Sculptures'
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=800&h=600&fit=crop',
      galleryName: 'The OZ',
      artist: 'OZ',
      artWork: 'Portrait'
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&h=600&fit=crop',
      galleryName: 'Fashion Forward',
      artist: 'Modern Designers',
      artWork: 'Contemporary Collection'
    },
    {
      id: 4,
      image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop',
      galleryName: 'Minimalist Space',
      artist: 'Clean Design',
      artWork: 'Modern Aesthetic'
    },
    {
      id: 5,
      image: 'https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=800&h=600&fit=crop',
      galleryName: 'Art Nouveau',
      artist: 'Classic Masters',
      artWork: 'Traditional Works'
    }
  ];

  const goToPrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const goToNext = () => {
    if (currentIndex < carouselItems.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const isFirstItem = currentIndex === 0;
  const isLastItem = currentIndex === carouselItems.length - 1;

  return (
    <div className={styles.featuredContainer}>
      <div className={styles.featuredSection}>
        <div className={styles.featuredHeader}>
          <Typography
            variant="heading2"
            fontFamily="satoshi"
            weight="bold"
            className={styles.title}>
            Featured Virtual Stores
          </Typography>
        </div>

        <div className={styles.featuredSubtitle}>
          <Typography
            variant="bodyRegular"
            fontFamily="satoshi"
            weight="regular"
            className={styles.subtitle}>
            Explore arts and product from the comfort of your home through the virtual stores
          </Typography>
        </div>

        <div className={styles.carouselWrapper}>
          <div className={styles.carouselContainer}>
            <div className={styles.sideImageWrapper}>
              {currentIndex > 0 ? (
                <AnimatedCard
                delay={200}
                  hoverEffect={false}
                  floatAnimation={true}
                  className={styles.sideCard}>

                <img
                  src={carouselItems[currentIndex - 1].image}
                  alt="Previous"
                  className={styles.sideImage}
                  onClick={goToPrevious}
                />
                </AnimatedCard>
              ) : (
                <div className={styles.placeholderImage}></div>
              )}
            </div>

            <div className={styles.mainImageContainer}>
              {!isFirstItem && (
                <button
                  onClick={goToPrevious}
                  className={`${styles.navButton} ${styles.navButtonLeft}`}
                  title="Previous Slide"
                  aria-label="Previous Slide"
                >
                  <img src={ChevronLeft} alt="Previous" className={styles.navIcon} />
                </button>
              )}

              <div className={styles.currentImageWrapper}>
                <AnimatedCard
                  delay={200}
                  hoverEffect={false}
                  floatAnimation={true}
                  className={styles.mainCard}>
                <img
                  src={carouselItems[currentIndex].image}
                  alt="Current"
                  className={styles.currentImage}
                />
                </AnimatedCard>
                <div className={styles.overlay}>
                  <div className={styles.overlayContent}>
                    <Typography
                      variant='bodyRegular'
                      fontFamily='helvetica'
                      weight='regular'
                      size='base'
                      className={styles.overlayText}>
                      Gallery: {carouselItems[currentIndex].galleryName}
                    </Typography>
                    <Typography
                      variant='bodyRegular'
                      fontFamily='helvetica'
                      weight='regular'
                      size='base'
                      className={styles.overlayText}>
                      Artist: {carouselItems[currentIndex].artist}
                    </Typography>
                    <Typography
                      variant='bodyRegular'
                      fontFamily='helvetica'
                      weight='regular'
                      size='base'
                      className={styles.overlayText}>
                      Artwork: {carouselItems[currentIndex].artWork}
                    </Typography>
                  </div>
                </div>
              </div>

              {!isLastItem && (
                <button
                  onClick={goToNext}
                  className={`${styles.navButton} ${styles.navButtonRight}`}
                  title="Next Slide"
                  aria-label="Next Slide"
                >
                  <img src={ChevronRight} alt="Next" className={styles.navIcon} />
                </button>
              )}
            </div>

            <div className={styles.sideImageWrapper}>
              {currentIndex < carouselItems.length - 1 ? (
                <AnimatedCard
                  delay={200}
                  hoverEffect={false}
                  floatAnimation={true}
                  className={styles.sideCard}>
                <img
                  src={carouselItems[currentIndex + 1].image}
                  alt="Next"
                  className={styles.sideImage}
                  onClick={goToNext}
                />
                </AnimatedCard>
              ) : (
                <div className={styles.placeholderImage}></div>
              )}
            </div>
          </div>

          <div className={styles.dotsContainer}>
            {carouselItems.map((_, index) => (
              <button
                type="button"
                key={index}
                title={`Go to slide ${index + 1}`}
                aria-label={`Go to slide ${index + 1}`}
                onClick={() => goToSlide(index)}
                className={`${styles.dot} ${index === currentIndex ? styles.dotActive : ''}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};